import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { BUSINESS_CASE, EQUIPMENT_TYPE as EquipmentType, SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE } from '../../../../../../constants/external-constants';
import {OR_RRF_TextArea as TextArea, OR_RRF_Select as Select, ORFButton as Button} from '../../../../../common/forms/order-request-form.component';
import { newMobileSubscriptionActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { CheckBox } from '../../../../../common/custom-form/checkbox.component';
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import { withRouter } from 'react-router-dom';
import { ConfirmationNotificationModal } from "../../../../../common/modal/confirmation-modal.component";
import { MAX_LENGTH, MODAL_TITLE } from '../../../../../../constants/external-constants';
import { toHaveAttribute } from '@testing-library/jest-dom';

class WirelessBusinessFormA extends Component {
    constructor(props) {
        super(props);
        this.state={
            show:false,
            isSaving:false,
            message: "",
            showConModal: false
        }
    }

    submitRequest = () => {       
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
              const { submitRequest, fetchRequestLogItems } = this.props;
              this.setState( prev => ({
                isSaving:true,
             }))

                var success = await submitRequest();
                if (success.Success) {
                    fetchRequestLogItems(0);
                    this.setState({
                        title:"Success"
                    })
                    this.props.hideRequestModal(); 
                }else {
                    this.setState({
                        title:"Error"
                    })
                }
                this.setState( prev => ({
                    showConModal: !prev.showConModal,
                    show:true, 
                    isSaving:false,
                    message:success.Message
                }))
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleCloseNotif = () => {
        this.setState({ show: false, isSaving:false });
        if(this.state.title!=="Error")
        {            
            this.props.history.goBack();
        }
    }

    render() {
        const {
            // component props
            prevAction
            , onClickCancel
            //form
            , wirelessLocationFormA
            , wirelessBusinessFormA 
            , onBussinessCaseSelect
            , wirelessSubscriptionFormA
            , isUpdate
        } = this.props;
        const { purposeOfUseOptions, businessCaseOptions, formSubmitted, employeeEquipmentProductNames, employeeEquipmentOnprogressProductNames } = this.props.newMobileRequest;
        const { requestData } = this.props.requestDetail;
        const showTermAgreement = (employeeEquipmentProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName != undefined ? wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value : requestData.MobileServiceTypeDetails[0].EquipmentModel)
                       || employeeEquipmentOnprogressProductNames.includes(wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName != undefined ? wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentProductName.value : requestData.MobileServiceTypeDetails[0].EquipmentModel))
                       &&  (wirelessSubscriptionFormA.mobileServiceModel[0].EquipmentTypeId.value === EquipmentType.Device);
        const initialRequired = wirelessBusinessFormA.purposeOfUseId === 0
            || wirelessBusinessFormA.busJustiCodeDetailId === 0
            || wirelessBusinessFormA.businessJustification === ''
            || (wirelessBusinessFormA.termAgreement === false && showTermAgreement === true)
            || formSubmitted;

        var isDiscountedOrderCostUpdated = false;
        if(wirelessSubscriptionFormA.mobileServiceModel[0]?.DiscountedOrderCost !== undefined || requestData.Subscription?.DiscountedOrderCost !== undefined){
            isDiscountedOrderCostUpdated = requestData.Subscription?.DiscountedOrderCost !== wirelessSubscriptionFormA.mobileServiceModel[0]?.DiscountedOrderCost?.value;
        }
        else {
            isDiscountedOrderCostUpdated = false;
        }

        var isLocationUpdated = false;
        if(wirelessLocationFormA.updatedLocationId?.value !== -1){
            if(wirelessLocationFormA.updatedLocationId?.value !== undefined){
                isLocationUpdated = requestData.Location?.LocationId !== wirelessLocationFormA.updatedLocationId?.value
            }
            else{
                isLocationUpdated = false;
            }
        }
        else {
            if(wirelessLocationFormA.otherDeliveryAddressId?.value !== undefined){
                isLocationUpdated = requestData.OtherLocationID !== wirelessLocationFormA.otherDeliveryAddressId?.value
            }
            else{
                isLocationUpdated = false;
            }
        }

        const updateRequired = !(requestData.OtherLocationName != wirelessLocationFormA.otherDeliveryAddress.value
            || requestData.Location.CountryCode != wirelessLocationFormA.countryCode.value
            || requestData.Subscription.PlanId != wirelessSubscriptionFormA.planId.value
            || requestData.Subscription.PhoneCaseAccessory != wirelessSubscriptionFormA.phoneCaseAccessory.value
            || requestData.Subscription.EquipmentCatalogId != wirelessSubscriptionFormA.equipmentCatalogId.value
            || requestData.Subscription.CircuitTypeId != wirelessSubscriptionFormA.circuitTypeId.value
            || requestData.Subscription.VendorDetailId != wirelessSubscriptionFormA.vendorDetailId.value
            || requestData.BusinessJustification.PurposeOfUseId != wirelessBusinessFormA.purposeOfUseId
            || requestData.BusinessJustification.BusJustiCodeDetailId != wirelessBusinessFormA.busJustiCodeDetailId
            || requestData.BusinessJustification.BusinessJustification != wirelessBusinessFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelessBusinessFormA.additionalInformation
            || isDiscountedOrderCostUpdated
            || isLocationUpdated);
            return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />

                <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={this.props.isUpdate ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={this.props.isUpdate ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <Form method="post" role="form"
                    model="wirelessBusinessFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('purpose_of_use')}`}
                                options={purposeOfUseOptions}
                                placeholder={'Select...'}
                                fieldProp='.purposeOfUseId'
                                value={wirelessBusinessFormA.purposeOfUseId}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('business_case')}`}
                                options={businessCaseOptions}
                                placeholder={'Select...'}
                                fieldProp='.busJustiCodeDetailId'
                                value={wirelessBusinessFormA.busJustiCodeDetailId}
                                onChangeAction={onBussinessCaseSelect}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea'>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelessBusinessFormA.businessJustification}
                                disabled={wirelessBusinessFormA.busJustiCodeDetailId != BUSINESS_CASE.other}
                                placeholder= "Enter text here…"
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='placeholder-padding-textarea'>
                            <TextArea 
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessBusinessFormA.additionalInformation}
                                placeholder= "Enter text here…"
                                maxLength={MAX_LENGTH.limit_1000}
                                customClass={"mb-0"}
                            />
                        </Col>
                    </Row>
                    {
                        showTermAgreement ? 
                            <ControlCheckBox
                                classWrapper="custom-checkbox-wrapper"
                                label={`${this.toLocaleLanguage('accept_request_submit')}`}
                                model="wirelessBusinessFormA.termAgreement"
                                isRequired
                                checked={wirelessBusinessFormA.termAgreement}
                                />
                        : null
                    }
                    <div className={`request-button-continer ${showTermAgreement? "" : "margin-top-25"}`}>
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    action={prevAction}
                                    className="btn-custom-violet-hover-outline"
                                    type="button"
                                />
                            </div>
                            <div>
                                <Button
                                    type={"submit"}
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    disabled={isUpdate ? (initialRequired || updateRequired) : initialRequired}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default withRouter (connect(
    state => {
        const { newMobileRequest, translation, requestDetail, createRequest } = state;
        const { wirelessBusinessFormA } = state.form;
        const { wirelessSubscriptionFormA, wirelessLocationFormA } = state.form.forms;
        return {
            newMobileRequest
            , wirelessBusinessFormA
            , wirelessSubscriptionFormA
            , wirelessLocationFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newMobileSubscriptionActions, requestLogActions),
            dispatch
        )
)(WirelessBusinessFormA));